import CompleteProfileForm from './components/CompleteProfileForm'

export default function RegisterComplete() {
  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 sm:px-8 py-10 sm:py-16">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="text-xs text-green-600 dark:text-green-400 uppercase tracking-widest font-semibold mb-2">
              Almost There
            </div>
            <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
              Complete Your Profile
            </h1>
            <p className="text-gray-500 text-sm">
              Just a few more details to set up your membership.
            </p>
          </div>
          <CompleteProfileForm />
        </div>
      </div>
    </div>
  )
}